import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import Card from "@material-ui/core/Card/Card";
import {createMuiTheme} from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import Button from "@material-ui/core/Button";

import { CustomizedSnackbars, ApolloMessage } from "../../../atom/Apollo_Mesasge";
import { ApolloContext } from "../../../atom/Apollo_Context";
import { 
  apollo_useStyles, 
  valueToOption, 
  options_status,
  options_usage,
} from "../../../atom/Apollo_styles";
import {
  apollo_users_path,
  geosegmenteditposeidon_path,
  list_poseidon_geosegments_path,
} from "../../../atom/Apollo_links";
import GenericTemplate from "../../../templates/GenericTemplate";
import { 
  Status,
  ListGeoSegment,
  ResListGeoSegment,
  GeoPoint,
} from "../../SEGMENT/poseidon/GeoSegmentModel";
import { ApolloAxios } from "../../../atom/Apollo_ApiRequest3";
import { ApolloBreadcrumbs2, BreadcrumbsData } from "../../../atom/Apollo_Breadcrumbs2";
import { STORAGE_KEY, ApolloDataTable } from "../../../atom/Apollo_DataTable";
import { ApolloRightDrawerContext } from "../../../molecule/Apollo_RightDrawer";
import { AreaSetting } from "../../../organism/SEGMENT/AreaSetting";
import { APOLLO_GROUP_OPERATOR, APOLLO_GROUP_READER } from "../../../atom/Apollo_Authorization";

import moment from "moment";
import "moment/locale/ja";
import { MUISortOptions, SelectableRows } from "mui-datatables";

import {Bars} from "react-loader-spinner";
import {Backdrop} from "@material-ui/core";

/*
    画面名：ジオセグメント一覧
 */
const GeoSegmentTop: React.FC = () => {
  const history = useHistory();
  const { state } = React.useContext(ApolloContext);
  const { data, setmsg } = React.useContext(ApolloMessage);

  const [geoSegments, setGeoSegments] = useState<ResListGeoSegment[]>([]);
  const [geoSegmentId, setGeoSegmentId] = useState<number>(0);
  const [geoSegmentName, setGeoSegmentName] = useState<string>("");
  const [displayUuColumnName, setDisplayUuColumnName] = useState("潜在リーチ数");
  const [roundingUu, setRoundingUu] = useState(true);
  const [description, setDescription] = useState<string>("");
  const {drawerState, setDrawerState} = React.useContext(ApolloRightDrawerContext);

  const [sortOrder, setSortOrder] = useState<MUISortOptions>({
    name: "id",
    direction: "asc",
  });
  const [numberOfRows, setNumberOfRows] = useState(10);
  const [progress, setProgress] = useState(false);

   // 潜在リーチ数の丸め処理に使う定数(一万の位まで表示)
  const roundingDigit = 10000

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 8,
    breadId: 15,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  React.useEffect(() => {
    // 特定の権限を持ったユーザの場合はUU数をそのまま表示する
    if (state.userprofile.systemAdmin > 0 ||
      state.current.geoSegment === 2 && state.current.roleAuthorization >= APOLLO_GROUP_OPERATOR) {
        setDisplayUuColumnName("UU");
        setRoundingUu(false);
    }

    // ユーザリスト取得
    let url: string = apollo_users_path;
    ApolloAxios.get(url).then(response => {
      let result1: any = response.data.result;

      var request: ListGeoSegment = {
        usage: "PRODUCTION",
        accountId: state.current.accountId,
      };

      // ジオセグメント一覧取得
      setProgress(true);
      url = `${list_poseidon_geosegments_path}/${state.current.accountGroupId}`;
      ApolloAxios.post(url, request).then(response => {
        let resultCode: number = response.data.resultCode;
        if (resultCode < 0 || resultCode === 2) {
          setProgress(false);
          let type1: string = "error";
          if (resultCode === 2) {
            type1 = "info";
          }

          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: type1,
              message: response.data.message,
            }
          });
          return;
        }

        let geosegments1: ResListGeoSegment[] = [];
        response.data.result.map((data: any) => {
          // エリア設定
          let geoPoints1: GeoPoint[] = [];
          if (data.geoPoints !== undefined) {
            data.geoPoints.map((geoPointId: any) => {
              let geoPoint1: GeoPoint = {
                id: geoPointId.id,
                geoPointId: geoPointId.geoPointId,
                segmentId: geoPointId.segmentId,
                type: geoPointId.type,
                latitude: geoPointId.latitude,
                longitude: geoPointId.longitude,
                areaWidth: geoPointId.areaWidth,
                wifiApId: geoPointId.wifiApId,
                name: geoPointId.name,
                address: geoPointId.address,
                dateFrom: geoPointId.dateFrom,
                dateTo: geoPointId.dateTo,
              };
              geoPoints1.push(geoPoint1);
            });
          }
          
          // アカウント連携 値セット
          let coordinated: string = "";

          if (data.coordinatedAccount !== undefined) {
            if (data.coordinatedAccount.length > 0) {
              coordinated = "済";
            }

            let accountNames: string = "";

            let apolloLists: any = state.apolloList;
            data.coordinatedAccount.map((coordinate: any) => {
              for(let apolloList of apolloLists) {
                if (apolloList.accountList === null) {
                  continue;
                }
  
                for(let list of apolloList.accountList){
                  if (coordinate === list.id) {
                    accountNames += list.name + ",";
                    break;
                  }
                };
              };
            });

            if (accountNames.length > 0) {
              accountNames = accountNames.substring(0, accountNames.length-1);
            }
            coordinated += ":::" + accountNames;
          }

          // UUセット
          let uuData: number = data.uu;
          if (data.uu === undefined) {
            uuData = 0;
          }

          // 更新者セット
          let updatedBy: string = "";
          result1.map((res1: any) => {
            if (data.updatedBy === res1.userId) {
              updatedBy = res1.familyName+" "+res1.firstName;
            }
          });

          let geosegment1: ResListGeoSegment = {
            id: data.id,
            name: data.name,
            status: data.status,
            description: data.description,
            uu: uuData,
            coordinatedAccount: coordinated,
            usage: valueToOption(data.usage, options_usage).label,
            accountGroupId: data.accountGroupId,
            updatedAt: data.updatedAt,
            updatedBy: updatedBy,
            geoPoints: geoPoints1,
          };
          geosegments1.push(geosegment1);
        });
        
        setGeoSegments(geosegments1);
      }).catch(err => {
        const errMsg = `ジオセグメント情報の取得に失敗しました。`
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg,
          }
        });
      }).finally(() => {
        setProgress(false);
      });
    }).catch(err => {
      const errMsg = `ユーザ情報の取得に失敗しました。`
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
    }).finally(() => {

    });
  }, []);

  // 情報(Drawer)
  const openInformation = (event: any, index: number) => {
    setGeoSegmentId(geoSegments[index].id);
    setGeoSegmentName(geoSegments[index].name);
    setDescription(geoSegments[index].description);

    setDrawerState({
      type: 'open',
      payload: {
        ...drawerState,
        open: true,
      }
    });
  }

  function closeInformation() {
    setDrawerState({
      type: 'close',
      payload: {
        ...drawerState,
        open: false,
      }
    });
  };

  const classes = apollo_useStyles();
  const theme = createMuiTheme({});
  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return value ? (
            <Tooltip title={valueToOption(value, options_status).label}>
              <span>
                {value === Status.Available ? (
                  <img
                    src={"/img/poseidon/success.png"}
                    alt="利用可"
                    height="32"
                    width="auto"
                  />
                ) : value === Status.Processing ? (
                  <img
                    src={"/img/poseidon/loading.gif"}
                    alt="処理中"
                    height="32"
                    width="auto"
                  />
                ) : (
                  <img
                    src={"/img/poseidon/error.png"}
                    alt="利用不可"
                    height="32"
                    width="auto"
                  />
                )}
              </span>
            </Tooltip>
          ) : (
            <div></div>
          );
        },
      },
    },
    {
      name: "name",
      label: "ジオセグメント名",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return (
            <Tooltip title={value}>
              <span>{value}</span>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "uu",
      label: displayUuColumnName,
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: number) => {
          if (roundingUu) {
            if (value < 5000) {
              return "10,000以下"
            }
            // 潜在リーチ数表示の場合は丸め処理(千の位で四捨五入)
            value = Math.round(value / roundingDigit) * roundingDigit
          }
          return value.toLocaleString();
        },
      },
    },
    {
      name: "coordinatedAccount",
      label: "アカウント連携",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {
          let accountNames: string = "";
          let doneValue: string = "";

          if (value === "") {
            return;
          }

          let splitVal = value.split(":::");
          accountNames = splitVal[1];
          doneValue = splitVal[0];

          return value !== "" ? (
            <Tooltip title={accountNames}>
              <span>{doneValue}</span>
            </Tooltip>
          ) : ("");
        },
      },
    },
    {
      name: "usage",
      label: "用途設定",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return value ? (
            <div>{value}</div>
          ) : (
            <div></div>
          );
        },
      },
    },
    {
      name: "inputType",
      label: "タイプ",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return <p>リアルタイム</p>;
        },
      },
    },
    {
        name: "area",
        label: "エリア設定",
        options: {
          filter: false,
          sort: false,
          customBodyRenderLite: (idx: number) => {
            return (
              <Button
                type="button"
                variant="contained"
                color="inherit"
                onClick={e => openInformation(e, idx)}
              >
                表示
              </Button>);
          },
        },
      },
    {
      name: "updatedBy",
      label: "最終更新ユーザ",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return (
            <p>{value}</p>
          );
        },
      },
    },
    {
      name: "updatedAt",
      label: "最終更新",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {
          return (
            <Tooltip
              title={moment(value).format("YYYY/MM/DD HH:mm:ss")}
            >
              <span>{moment(value).fromNow()}</span>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: number, tableMeta: any) => {
          let geoSegmentId: number = tableMeta.rowData[0];
          let isEdit: boolean = false;
          let isPossibleRole: boolean = false;
          let accountGroupId: number = 0;
          let status: string = "";

          if (state.userprofile.systemAdmin > 0 || 
              (state.current.roleAuthorization > APOLLO_GROUP_READER && state.current.geoSegment >= 2)) {
            isPossibleRole = true;
          }

          geoSegments.map((geoSegment: any) => {
            if (geoSegment.id === geoSegmentId) {
              accountGroupId = geoSegment.accountGroupId;
              status = geoSegment.status;
            }
          });

          if (accountGroupId === state.current.accountGroupId && isPossibleRole) {
            isEdit = true;
          }

          return isEdit ? (
            <Tooltip title="ジオセグメント編集" placement="top">
              <KeyboardArrowRightIcon
                onClick={() =>
                  history.push(`${geosegmenteditposeidon_path}${geoSegmentId}?type=prod`)
                }
                className={classes.link}
                style={{ cursor: "pointer" }}
              />
            </Tooltip>
          ) : (
            ""
          );
        },
      },
    },
  ];

  const selectableRows: SelectableRows = "none";
  const options = {
    filter: true,
    download: false,
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.GEO_SEGMENT) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: numberOfRows,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.GEO_SEGMENT,
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setSortOrder({
        name: changedColumn,
        direction: direction,
      } as MUISortOptions)
    },
    onChangeRowsPerPage: (numberOfRows: number) => setNumberOfRows(numberOfRows),
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  };

  return (
    <div>
      <GenericTemplate title={""}>
        <Backdrop className={classes.backdrop2} open={progress}>
          <Bars color="#00BFFF" height={80} width={80} />
        </Backdrop>
        <CustomizedSnackbars />
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>
        <Card className={classes.root} square variant="outlined">
          <ApolloDataTable
            title=""
            data={geoSegments ? geoSegments : []}
            columns={columns}
            options={options}
          />
        </Card>

        {drawerState.open ? 
          <AreaSetting 
            geoSegments={geoSegments}
            geoSegmentId={geoSegmentId}
            geoSegmentName={geoSegmentName}
            description={description}
            closeInformation={closeInformation}
          />
        : ""}
      </GenericTemplate>
    </div>
  );
};

export default GeoSegmentTop;
